import { useEffect } from "react";
import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import LoadingComponent from "../../../components/Loading";

import { useSelector } from "react-redux";
import { FaArrowDown, FaArrowLeft, FaArrowUp } from "react-icons/fa";

import { selectUsuarioSeleccionado } from "../../../redux/reducer/loginReducer";
import TituloPagina from "../../../components/Titulos/TituloPagina";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Link,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
} from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { cmi_cuestionario_satisfaccion } from "../../../services/alumnos";

import Masonry from 'react-masonry-css';
import './masonry.css'; // Necesitarás crear este archivo


import { Bar, Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);


/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "80px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "90vh",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    width: "100%",
    flexDirection: "column",
    textAlign: "center",
  },
  emptyImage: {
    width: "100%",
  },
  rootFilter: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: "space-between",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  textFieldFilter: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    margin: theme.spacing(1, 0.5, 1.5),
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(0.5),
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  enlace: {
    color: theme.palette.link.main,
    textDecoration: "none",
  },
}));

export default function SatisfaccionContent() {
  const classes = useStyles();

  const [loadingMotivacion, setLoadingMotivacion] = useState(false);
  const [loadingRelacionTutor, setLoadingRelacionTutor] = useState(false);
  const [loadingValoracionMaterial, setLoadingValoracionMaterial] = useState(false);
  const [loadingMensaje, setLoadingMensaje] = useState("");
  const [datosGraficas, setDatosGraficas] = useState({
    motivacion: [],
    relacion_tutor: [],
    valoracion_material: []
  });
  const [comentarios, setComentarios] = useState([]);
  const [mediaTutores, setMediaTutores] = useState(null);

  const usuarioSeleccionado = useSelector((state) => {
    return selectUsuarioSeleccionado(state);
  });

  /* -------------------------------------------------------------------------- */
  /*                                  UseEffect                                 */
  /* -------------------------------------------------------------------------- */
  const transformarDatos = (resultado) => {
        const dataArray = new Array(10).fill(0);
        if (Array.isArray(resultado)) {
          resultado.forEach(item => {
            const nivel = parseInt(item.nivel);
            if (nivel >= 1 && nivel <= 10) {
              dataArray[nivel - 1] = parseInt(item.total);
            }
          });
        }
        return dataArray;
      };

  const fetchDatos = async () => {
      setLoadingMotivacion(true);
      setLoadingRelacionTutor(true);
      setLoadingValoracionMaterial(true);
      setLoadingMensaje("Cargando estadísticas...");

      // Motivación
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "motivacion"}).then((respuesta) => {

        setLoadingMotivacion(false);
        setDatosGraficas((prevState) => ({
          ...prevState,
          motivacion: transformarDatos(respuesta.resultado),
        }));

      });
      
      // Relación con el tutor
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "relacion_tutor"}).then((respuesta) => {

        setLoadingRelacionTutor(false);
        setDatosGraficas((prevState) => ({
          ...prevState,
          relacion_tutor: transformarDatos(respuesta.resultado),
        }));

      });
      
      // Valoración del material
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "valoracion_material"}).then((respuesta) => {

        setLoadingValoracionMaterial(false);
        setDatosGraficas((prevState) => ({
          ...prevState,
          valoracion_material: transformarDatos(respuesta.resultado),
        }));

      });
      
      // Comentarios
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "comentarios"}).then((respuesta) => {

        setComentarios(respuesta.resultado);

      });
      
      // Media tutores
      cmi_cuestionario_satisfaccion({usuario_id: usuarioSeleccionado.id, indicador: "media_tutores"}).then((respuesta) => {

        setMediaTutores(respuesta.resultado);

      });


      
  }

  useEffect(() => {
    fetchDatos();
  }, [usuarioSeleccionado]);


  /* -------------------------------------------------------------------------- */
  /*                                  Contenido                                 */
  /* -------------------------------------------------------------------------- */

  const RenderGrafica = ({ titulo, dataValues }) => {
    const totalRespuestas = dataValues.reduce((a, b) => a + b, 0);

    const media = totalRespuestas > 0 
      ? dataValues.reduce((acc, value, index) => acc + (value * (index + 1)), 0) / totalRespuestas
      : 0;

    const data = {
      labels: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      datasets: [
        {
          data: dataValues,
          backgroundColor: "#6C2DF0",
          borderRadius: 4,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 30, // Añade espacio extra en la parte superior del canvas
        },
      },
      plugins: {
        legend: { display: false },
        datalabels: {
          anchor: "end",
          align: "top",
          offset: 4,
          clip: false, // Evita que la etiqueta se corte si sale del área de dibujo
          formatter: (value) => {
            if (value === 0) return "";
            const percentage = totalRespuestas > 0 ? ((value / totalRespuestas) * 100).toFixed(1) : 0;
            return `${value} (${percentage} %)`;
          },
          font: { weight: "bold", size: 11 },
          color: "#444",
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          grace: '15%', // Añade un 15% de espacio extra sobre el valor máximo automáticamente
          grid: { drawBorder: false },
        },
        x: {
          grid: { display: false },
        },
      },
    };

    return (
      <Grid item xs={12} md={6} lg={4}>
        <Card style={{ marginBottom: 20 }}>
          <CardContent>
            <Typography variant="subtitle1" style={{ fontWeight: 'bold', minHeight: 60 }}>
              {titulo}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {totalRespuestas} respuestas
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{color: "#6C2DF0"}}>
              Media: {media.toFixed(1)}
            </Typography>
            <Box style={{ height: 300, marginTop: 20 }}>
              <Bar data={data} options={options} />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  const MediaTutores = ({ mediaTutores }) => {

  if (!mediaTutores || mediaTutores.length === 0) return null;

  const renderDiffIcon = (diff) => {
    if (diff === null || diff === undefined || diff === "") return null;

    const diffValue = parseFloat(diff);
    if (Number.isNaN(diffValue)) return null;

    if (diffValue > 0) return <FaArrowUp style={{ color: "green" }} />;
    if (diffValue < 0) return <FaArrowDown style={{ color: "red" }} />;

    return <FaArrowLeft style={{ color: "orange" }} />;
  };

  const renderValueWithDiff = (value, diff) => {
    const hasValue = value !== null && value !== undefined && value !== "";
    const formattedValue = hasValue ? parseFloat(value).toFixed(1) : "-";

    return (
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          whiteSpace: "nowrap",
        }}
      >
        <span>{formattedValue}</span>
        {renderDiffIcon(diff)}
      </Box>
    );
  };

  return (
    <TableContainer component={Paper} elevation={0} variant="outlined">
      <Table
        size="small"
        style={{
          borderCollapse: "collapse",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2} style={{ fontWeight: "bold" }}></TableCell>
            <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
              Valoraciones
            </TableCell>
            <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
              Motivación
            </TableCell>
            <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
              Tutorización
            </TableCell>
            <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
              Materiales
            </TableCell>
            <TableCell colSpan={2} align="center" style={{ fontWeight: "bold" }}>
              Nos recomendaria
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              12/2025
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              03/2026
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              12/2025
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              03/2026
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              12/2025
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              03/2026
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              12/2025
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              03/2026
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              03/2026
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {mediaTutores.map((tutor, index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row" style={{ fontWeight: "bold", padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>
                {tutor.tutor_nombre}
              </TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>{tutor.total_12_2025}</TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>{tutor.total_03_2026}</TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>
                {tutor.motivacion_12_2025
                  ? parseFloat(tutor.motivacion_12_2025).toFixed(1)
                  : "-"}
              </TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>
                {renderValueWithDiff(
                  tutor.motivacion_03_2026,
                  tutor.motivacion_diff,
                )}
              </TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>
                {tutor.relacion_tutor_12_2025
                  ? parseFloat(tutor.relacion_tutor_12_2025).toFixed(1)
                  : "-"}
              </TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>
                {renderValueWithDiff(
                  tutor.relacion_tutor_03_2026,
                  tutor.relacion_tutor_diff,
                )}
              </TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>
                {tutor.valoracion_material_12_2025
                  ? parseFloat(tutor.valoracion_material_12_2025).toFixed(1)
                  : "-"}
              </TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap", borderRight: "1px solid #e0e0e0" }}>
                {renderValueWithDiff(
                  tutor.valoracion_material_03_2026,
                  tutor.valoracion_material_diff,
                )}
              </TableCell>
              <TableCell align="center" style={{ padding: "6px 8px", whiteSpace: "nowrap" }}>
                {tutor.recomendarian_03_2026}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
              Media
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
              {(() => {
                const values = mediaTutores.map(t => parseFloat(t.motivacion_12_2025) || 0).filter(v => v !== 0);
                return values.length > 0 ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1) : "-";
              })()}
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
              {(() => {
                const values = mediaTutores.map(t => parseFloat(t.motivacion_03_2026) || 0).filter(v => v !== 0);
                return values.length > 0 ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1) : "-";
              })()}
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
              {(() => {
                const values = mediaTutores.map(t => parseFloat(t.relacion_tutor_12_2025) || 0).filter(v => v !== 0);
                return values.length > 0 ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1) : "-";
              })()}
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
              {(() => {
                const values = mediaTutores.map(t => parseFloat(t.relacion_tutor_03_2026) || 0).filter(v => v !== 0);
                return values.length > 0 ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1) : "-";
              })()}
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
              {(() => {
                const values = mediaTutores.map(t => parseFloat(t.valoracion_material_12_2025) || 0).filter(v => v !== 0);
                return values.length > 0 ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1) : "-";
              })()}
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", borderRight: "1px solid #e0e0e0", backgroundColor: "#f5f5f5" }}>
              {(() => {
                const values = mediaTutores.map(t => parseFloat(t.valoracion_material_03_2026) || 0).filter(v => v !== 0);
                return values.length > 0 ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1) : "-";
              })()}
            </TableCell>
            <TableCell align="center" style={{ fontWeight: "bold", padding: "6px 8px", backgroundColor: "#f5f5f5" }}>
              {(() => {
                const values = mediaTutores.map(t => parseInt(t.recomendarian_03_2026) || 0).filter(v => v !== 0);
                return values.length > 0 ? (values.reduce((a, b) => a + b, 0) / values.length).toFixed(1) : "-";
              })()}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};
  const GraficaMediasTutores = () => {
    if (!mediaTutores || mediaTutores.length === 0) return null;

    const labels = mediaTutores.map((t) => t.tutor_nombre);
    const data = {
      labels,
      datasets: [
        {
          label: "Motivación",
          data: mediaTutores.map((t) => parseFloat(t.motivacion_03_2026 || 0)),
          backgroundColor: "#ECB3D0",
          borderRadius: 4,
        },
        {
          label: "Tutorización",
          data: mediaTutores.map((t) => parseFloat(t.relacion_tutor_03_2026 || 0)),
          backgroundColor: "#6C2DF0",
          borderRadius: 4,
        },
        {
          label: "Materiales",
          data: mediaTutores.map((t) => parseFloat(t.valoracion_material_03_2026 || 0)),
          backgroundColor: "#60DDD1",
          borderRadius: 4,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: true, position: "bottom" },
        datalabels: {
          anchor: "end",
          align: "top",
          formatter: (value) => (value > 0 ? value.toFixed(1) : ""),
          font: { weight: "bold", size: 10 },
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          max: 10,
          grid: { drawBorder: false },
        },
        x: {
          grid: { display: false },
        },
      },
    };

    return (
      <Card style={{ marginBottom: 20 }}>
      <CardContent>
        <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
        Comparativa de Medias por Tutor
        </Typography>
        <Box style={{ height: 400, marginTop: 20 }}>
        <Bar 
          data={data} 
          options={{ ...options, indexAxis: 'y' }} 
        />
        </Box>
      </CardContent>
      </Card>
    );
  };
  
  const Contenido = () => {
    // Datos de ejemplo basados en tu imagen

    return (
      <>
        <TituloPagina titulo={"Cuestionario de Satisfacción"} />

        <Box display="flex" justifyContent="" style={{ padding: "0 20px" }}>
          <Link
            href="https://gestion.innovatiio.com/api/v1/alumno/exportar_cmi_cuestionario_satisfaccion"
            target="_blank"
            className={classes.enlace}
            style={{ fontWeight: "bold" }}
          >
            Exportar CSV
          </Link>
        </Box>

        <Grid style={{ marginTop: 45, padding: "0 15px" }}>
          <Grid container spacing={3}>
            <RenderGrafica 
              titulo="¿Cómo estás de motivado/a en este momento de cara a la oposición?" 
              dataValues={datosGraficas.motivacion} 
            />
            <RenderGrafica 
              titulo="Valoración de la relación con tu tutor/a" 
              dataValues={datosGraficas.relacion_tutor} 
            />
            <RenderGrafica 
              titulo="Valoración del material de estudio" 
              dataValues={datosGraficas.valoracion_material} 
            />
          </Grid>

          <Box style={{ marginTop: 40 }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: 20 }}>
              Medias por tutor
            </Typography>
            <Grid container spacing={3}>
              {/* <Grid item xs={12} lg={6}>
                <GraficaComparativaTutores />
              </Grid> */}
              {/* <Grid item xs={12} lg={4}>
                <GraficaMediasTutores />
              </Grid> */}
              <Grid item xs={12}>
                <MediaTutores mediaTutores={mediaTutores} />
              </Grid>
            </Grid>
          </Box>
         
          <Box style={{ marginTop: 40 }}>
            <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: 20 }}>
              Comentarios adicionales
            </Typography>
            {comentarios && comentarios.length === 0 ? (
              <Typography variant="body2" color="textSecondary">
                No hay comentarios disponibles.
              </Typography>
            ) : (
              <Masonry
                breakpointCols={{ default: 2, 960: 1 }}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
              >
                {comentarios && comentarios.map((comentario, index) => (
                  <Paper key={index} elevation={1}>
                    <Box p={2}>
                      <Typography variant="body1" style={{ marginBottom: 12 }}>
                        {comentario.comentario}
                      </Typography>
                      <Link 
                        href={`/alumnos/detalle/${comentario.alumno_id}`} 
                        style={{ textDecoration: 'none' }}
                      >
                        <Typography 
                          variant="body2" 
                          style={{ fontWeight: 'bold', color: "#666", marginTop: 8 }}
                        >
                          {comentario.alumno_nombre}
                        </Typography>
                      </Link>
                      <Typography 
                        variant="body2" 
                        style={{ marginTop: 4, color: "#999" }}
                      >
                        Tutor: {comentario.tutor_nombre}
                      </Typography>
                    </Box>
                  </Paper>
                ))}
              </Masonry>
            )}
          </Box>
        </Grid>
      </>
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                                   Return                                   */
  /* -------------------------------------------------------------------------- */
  return (
    <div className={classes.container}>
        <Contenido />
    </div>
  );
}

